<template>
  <el-container v-if="organizationStructureVisible">
    <el-tree v-if="user" ref="tree" :load="loadNode" :props="organizationStructure" :render-content="render" default-expand-all lazy node-key="departmentId"
             style="margin: 40px">
    </el-tree>
    <el-dialog
        :visible.sync="dialogVisible"
        title="提示"
        width="30%">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
    </el-dialog>

    <el-dialog
        :visible.sync="createDepartmentDialog.visible"
        title="创建新部门"
        width="30%">

      <el-row justify="space-between" type="flex">
                <span style="height: 100%;">
                    <span style="height: 100%; line-height: 40px;">部门名称</span>
                </span>
        <span>
                    <el-input v-model="createDepartmentDialog.departmentName" placeholder="新部门名称" style="width: 193px;"></el-input>
                </span>
      </el-row>

      <el-row justify="space-between" style="margin-top: 10px;" type="flex">
                <span style="height: 100%;">
                    <span style="height: 100%; line-height: 40px;">部门负责人</span>
                </span>
        <span>
                    <el-select v-model="createDepartmentDialog.leader" :remote-method="onSearchEmployee" filterable placeholder="新部门负责人" remote>
                        <el-option
                            v-for="item in employees"
                            :key="item.userId"
                            :label="item.name"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </span>
      </el-row>

      <span slot="footer" class="dialog-footer">
                <el-button @click="createDepartmentDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="createDepartmentButtonClick">确 定</el-button>
            </span>
    </el-dialog>

    <el-dialog
        :visible.sync="editDepartmentDialog.visible"
        title="编辑部门"
        width="30%">

      <el-row justify="space-between" type="flex">
                <span style="height: 100%;">
                    <span style="height: 100%; line-height: 40px;">部门名称</span>
                </span>
        <span>
                    <el-input v-model="editDepartmentDialog.departmentName" placeholder="新部门名称" style="width: 193px;"></el-input>
                </span>
      </el-row>

      <el-row justify="space-between" style="margin-top: 10px;" type="flex">
                <span style="height: 100%;">
                    <span style="height: 100%; line-height: 40px;">部门负责人</span>
                </span>
        <span>
                    <el-select v-model="editDepartmentDialog.leader" :remote-method="onSearchEmployee" filterable placeholder="新部门负责人" remote>
                        <el-option
                            v-for="item in employees"
                            :key="item.userId"
                            :label="item.name"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </span>
      </el-row>

      <span slot="footer" class="dialog-footer">
                <el-button @click="editDepartmentDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="editDepartmentButtonClick">确 定</el-button>
            </span>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from "axios";
import app from "@/App";
import qs from "qs";

export default {
  name: "OrganizationStructure",
  data() {
    return {
      organizationStructureVisible: true,
      organizationStructure: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      user: null,
      dialogContent: '',
      dialogVisible: false,

      createDepartmentDialog: {
        visible: false,
        departmentName: '',
        leader: null,
      },

      editDepartmentDialog: {
        visible: false,
        departmentName: '',
        leader: null,
        level: 1,
      },

      currentNode: {},
      currentData: {},

      employees: []
    };
  },
  created() {
    app.methods.getUser().then(res => {
      this.user = res.data.data;
    });
  },
  methods: {
    onSearchEmployee(keyword) {
      if (keyword) {
        app.methods.searchEmployees(keyword).then(res => {
          this.employees = res.data.data.employees;
        })
      } else {
        this.employees = []
      }
    },
    addDepartment: function (node, data) {
      this.currentNode = node;
      this.currentData = data;
      this.openCreateDepartmentDialog();
    },
    deleteDepartment: function (node, data) {
      axios.post(app.url + '/department/delete/' + data.departmentId).then(res => {
        if (res.data.code === "0") {
          this.$refs.tree.remove(data)
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    showAlertDialog(content) {
      this.dialogContent = content;
      this.dialogVisible = true;
    },
    closeAlertDialog() {
      this.dialogVisible = false;
    },
    openLoginPage() {
      this.$router.replace({path: '/login'})
    },
    openCreateDepartmentDialog() {
      this.createDepartmentDialog.visible = true;
      this.createDepartmentDialog.departmentName = '';
      this.createDepartmentDialog.leader = this.user.userId;
      this.employees = [this.user];
    },
    createDepartmentButtonClick() {
      if (!this.createDepartmentDialog.departmentName) {
        alert('部门名称不能为空');
        return;
      }
      if (!this.createDepartmentDialog.leader) {
        alert('部门负责人不能为空');
        return;
      }
      if (this.createDepartmentDialog.level < 1 || 5 < this.createDepartmentDialog.level) {
        this.showAlertDialog('部门级别必须在1和5之间')
        return
      }

      this.createDepartmentDialog.visible = false;
      axios.post(app.url + '/department/add',
          qs.stringify({
            cId: this.user.companyId,
            parentId: this.currentData.departmentId,
            name: this.createDepartmentDialog.departmentName,
            leader: this.createDepartmentDialog.leader,
          })).then(res => {
        if (res.data.code === "0") {
          this.organizationStructureVisible = false;
          this.$nextTick(() => {
            this.organizationStructureVisible = true;
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    editDepartmentButtonClick() {
      axios.post(app.url + '/department/update',
          {
            user_id: this.user.userId,
            cId: this.currentData.cId,
            leader: this.editDepartmentDialog.leader,
            parentId: this.currentData.parentId,
            departmentId: this.currentData.departmentId,
            name: this.editDepartmentDialog.departmentName
          }).then(res => {
        if (res.data.code !== "0") {
          this.$message.error(res.data.msg);
        } else if (res.data.status === 3) {
          this.showAlertDialog(res.data.info)
        } else {
          this.organizationStructureVisible = false;
          this.$nextTick(() => {
            this.organizationStructureVisible = true;
          });
          this.editDepartmentDialog.visible = false;
        }
      });
    },
    async getDepartments(departmentId = 0) {
      let res = await app.methods.getSubDepartments(departmentId);
      return res.data.data;
    },
    loadNode(node, resolve) {
      this.getDepartments(node.data ? node.data.departmentId : 0).then(departments => {
        console.log(departments)
        return resolve(departments);
      })
    },
    render(h, {node, data}) {
      return h('div', {
        style: {
          flex: 1,
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'space-between',
          'font-size': '14px',
          'padding-right': '8px'
        }
      }, [
        h('div', {style: {'padding-right': '10px'}}, [
          h('span', {style: {'padding-right': '10px'}}, data.name),

        ]),
        h('div', {
          style: {
            flex: 1,
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'flex-end',
            'font-size': '14px',
            'padding-right': '8px'
          }
        }, [
          h('div', {
            style: {
              'color': '#aaa',
              'font-size': '12px',
              'padding-right': '10px',
              'width': '180px'
            }
          }, data.leaderName ? '负责人: ' + data.leaderName : ''),
          h('el-button', {
            attrs: {type: 'text'}, on: {
              click: event => {
                event.stopPropagation();
                this.addDepartment(node, data);
              }
            }
          }, '添加'),
          h('el-button', {
            attrs: {type: 'text'}, on: {
              click: event => {
                event.stopPropagation();
                this.openEditDepartmentDialog(node, data);
              }
            }
          }, '编辑'),
          h('el-button', {
            attrs: {type: 'text'}, on: {
              click: event => {
                event.stopPropagation();
                this.deleteDepartment(node, data);
              }
            }
          }, '删除'),])
      ]);
    },
    openEditDepartmentDialog(node, data) {
      this.currentNode = node;
      this.currentData = data;
      this.editDepartmentDialog.departmentName = data.name;
      this.editDepartmentDialog.leader = data.leader;
      this.employees = [{userId: data.leader, name: data.leaderName}];
      this.editDepartmentDialog.visible = true;
      this.editDepartmentDialog.level = data.natureLevel;
    },
  }
}
</script>
